'use client';

import { base64ToObject } from '@bgzt/utils';
import { DeviceType, LogParams, postLog } from '~/apis/log';
import { APP_LOG_CONTEXT_STORAGE_KEY } from '~/services/app-interface';
import { getQueryParam } from '~/utils';
import { useMediaQuery } from './useMediaQuery';

export const useSendLog = () => {
  const isPc = useMediaQuery('(min-width: 968px)');
  const getLogContext = () => {
    const queryLogContext = getQueryParam('logContext');
    const sessionLogContext = globalThis.window.sessionStorage.getItem(APP_LOG_CONTEXT_STORAGE_KEY);
    const storedLogContext = queryLogContext ?? sessionLogContext;
    return storedLogContext ? base64ToObject(storedLogContext) : {};
  };

  const defaultLogParams = {
    event_source: 'bunjang-app' as const,
    event_time: new Date(),
    device_type: (isPc ? 'w' : 'm') as DeviceType,
    language: globalThis.window?.navigator?.language,
    ref_url: globalThis.window?.document?.referrer,
    url: globalThis.window?.location?.href,
  };

  const sendLog = (params: LogParams) => {
    const logParams = {
      ...defaultLogParams,
      ...getLogContext(),
      ...params,
    };
    postLog(logParams);
  };
  return sendLog;
};
